import React from 'react';
import {
  string, shape, arrayOf, bool,
} from 'prop-types';
import { withRouter } from 'react-router';
import withSubscribe from 'containers/withSubscribe';
import withApplicationConfig from 'containers/withApplicationConfig';
import SupportButtonStateContainer from 'containers/SupportButtonStateContainer';
import loadZen from './loadZen';

class SupportButton extends React.Component {
  componentDidMount() {
    const {
      zenKey,
      zendeskLocales,
      language,
      subscribedContainers,
      supportButtonBlacklist,
      location,
    } = this.props;
    const onBlacklist = supportButtonBlacklist.filter(path => location.pathname.includes(path));
    if (onBlacklist.length > 0) {
      return;
    }
    const [supportButtonState] = subscribedContainers;
    // Only run on client side and if zendesk key exists
    if (typeof window === 'undefined' || typeof document === 'undefined' || !zenKey) return;

    // Load Zen script only when user starts interacting with the page
    let isZenLoaded = false;

    document.addEventListener('mousedown', () => {
      if (isZenLoaded) return;
      isZenLoaded = true;
      loadZen(zenKey, zendeskLocales[language], () => {
        supportButtonState.setIsLoaded(true);
      });
    });

    document.addEventListener('mousemove', () => {
      if (isZenLoaded) return;
      isZenLoaded = true;
      loadZen(zenKey, zendeskLocales[language], () => {
        supportButtonState.setIsLoaded(true);
      });
    });

    document.addEventListener('touchstart', () => {
      if (isZenLoaded) return;
      isZenLoaded = true;
      loadZen(zenKey, zendeskLocales[language], () => {
        setTimeout(() => {
          supportButtonState.setIsLoaded(true);
        }, 1000);
      });
    });

    document.addEventListener('touchmove', () => {
      if (isZenLoaded) return;
      isZenLoaded = true;
      loadZen(zenKey, zendeskLocales[language], () => {
        setTimeout(() => {
          supportButtonState.setIsLoaded(true);
        }, 1000);
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (typeof window === 'undefined') return;
    if (!window.zE) return;

    const {
      homepageSearchKey,
      preLoginEnableForm,
      postLoginEnableForm,
      postLoginFormId,
      subscribedContainers,
      language,
    } = this.props;
    const {
      zendeskLocales,
      location,
    } = prevProps;

    window.zE('webWidget', 'setLocale', zendeskLocales[language]);

    const [supportButtonState] = subscribedContainers;
    const { isLoggedIn } = supportButtonState.state;
    const { firstName } = supportButtonState.state;
    const { email } = supportButtonState.state;

    if (isLoggedIn) {
      window.zE('webWidget', 'prefill', {
        name: {
          value: `${firstName}`,
        },
        email: {
          value: email,
          readOnly: true,
        },
      });

      window.zESettings = {
        webWidget: {
          contactForm: {
            suppress: !postLoginEnableForm,
            ticketForms: [{ id: postLoginFormId[language] || 0 }],
            // 0 for loading the default form of the ZenDesk AC
            // If the ZenDesk AC has no forms, form option will be disabled
          },
        },
      };
    } else {
      window.zESettings = {
        webWidget: {
          contactForm: {
            suppress: !preLoginEnableForm,
          },
        },
      };
    }

    // applies to TW/SG
    if (location.pathname === '/') {
      window.zE('webWidget', 'helpCenter:setSuggestions', { search: homepageSearchKey });
    }
  }

  render() {
    return (
      <div className="loadzen" />
    );
  }
}

SupportButton.propTypes = {
  zenKey: string,
  zendeskLocales: shape({}),
  location: shape({}).isRequired,
  language: string.isRequired,
  subscribedContainers: arrayOf(shape({})),
  homepageSearchKey: string,
  supportButtonBlacklist: arrayOf(string),
  preLoginEnableForm: bool,
  postLoginEnableForm: bool,
  postLoginFormId: shape({}),
};

SupportButton.defaultProps = {
  zenKey: null,
  zendeskLocales: {},
  subscribedContainers: [],
  homepageSearchKey: 'general',
  supportButtonBlacklist: [],
  preLoginEnableForm: false,
  postLoginEnableForm: false,
  postLoginFormId: {},
};

export default withSubscribe(withRouter(withApplicationConfig(SupportButton, ['languages', 'zendesk'])))([SupportButtonStateContainer]);
